// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"Card-CardFooter-module--card-footer--blZ5u"};